import { render, staticRenderFns } from "./ViewArchivalApplications.vue?vue&type=template&id=085d2ee2&scoped=true"
import script from "./ViewArchivalApplications.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewArchivalApplications.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ViewArchivalApplications.vue?vue&type=style&index=0&id=085d2ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085d2ee2",
  null
  
)

export default component.exports